<div class="container-habilidades">
    <div class="titulo">
        <h1>Habilidades</h1>
    </div>
    <div class="container">
        <div class="lenguaje-programacion">
            <h1 class="text-light">Angular</h1>
            <div class="row">
                <div class="col-6 col-lg-3">
                    <img src="assets/images/Angular js.png" alt="angular" class="img-thumbnail">
                </div>
                <div class="col-6 col-lg-9 container-porcentaje">
                    <div class="porcentaje">
                        <div class="cantidad-porcentaje" style="width: 65%;">65%</div>
                    </div>
                </div>
            </div>
        </div>
        <hr>
        <div class="lenguaje-programacion">
            <h1 class="text-light">Html</h1>
            <div class="row">
                <div class="col-6 col-lg-3">
                    <img src="assets/images/html.png" alt="angular" class="img-thumbnail">
                </div>
                <div class="col-6 col-lg-9 container-porcentaje">
                    <div class="porcentaje">
                        <div class="cantidad-porcentaje" style="width: 90%;">90%</div>
                    </div>
                </div>
            </div>
        </div>
        <hr>
        <div class="lenguaje-programacion">
            <h1 class="text-light">CSS</h1>
            <div class="row">
                <div class="col-6 col-lg-3">
                    <img src="assets/images/css.png" alt="angular" class="img-thumbnail">
                </div>
                <div class="col-6 col-lg-9 container-porcentaje">
                    <div class="porcentaje">
                        <div class="cantidad-porcentaje" style="width: 75%;">75%</div>
                    </div>
                </div>
            </div>
        </div>
        <hr>
        <div class="lenguaje-programacion">
            <h1 class="text-light">Javascript</h1>
            <div class="row">
                <div class="col-6 col-lg-3">
                    <img src="assets/images/javascript.png" alt="angular" class="img-thumbnail">
                </div>
                <div class="col-6 col-lg-9 container-porcentaje">
                    <div class="porcentaje">
                        <div class="cantidad-porcentaje" style="width: 60%;">60%</div>
                    </div>
                </div>
            </div>
        </div>
        <hr>
        <div class="lenguaje-programacion">
            <h1 class="text-light">Bootstrap</h1>
            <div class="row">
                <div class="col-6 col-lg-3">
                    <img src="assets/images/bootstrap.png" alt="angular" class="img-thumbnail">
                </div>
                <div class="col-6 col-lg-9 container-porcentaje">
                    <div class="porcentaje">
                        <div class="cantidad-porcentaje" style="width: 90%;">90%</div>
                    </div>
                </div>
            </div>
        </div>
        <hr>
        <div class="lenguaje-programacion">
            <h1 class="text-light">TypeScript</h1>
            <div class="row">
                <div class="col-6 col-lg-3">
                    <img src="assets/images/typescript.png" alt="angular" class="img-thumbnail">
                </div>
                <div class="col-6 col-lg-9 container-porcentaje">
                    <div class="porcentaje">
                        <div class="cantidad-porcentaje" style="width: 60%;">60%</div>
                    </div>
                </div>
            </div>
        </div>
        <hr>
        <div class="lenguaje-programacion">
            <h1 class="text-light">Node js</h1>
            <div class="row">
                <div class="col-6 col-lg-3">
                    <img src="assets/images/nodejs.png" alt="angular" class="img-thumbnail">
                </div>
                <div class="col-6 col-lg-9 container-porcentaje">
                    <div class="porcentaje">
                        <div class="cantidad-porcentaje" style="width: 50%;">50%</div>
                    </div>
                </div>
            </div>
        </div>
        <hr>
        <div class="lenguaje-programacion">
            <h1 class="text-light">PHP</h1>
            <div class="row">
                <div class="col-6 col-lg-3">
                    <img src="assets/images/php.png" alt="angular" class="img-thumbnail">
                </div>
                <div class="col-6 col-lg-9 container-porcentaje">
                    <div class="porcentaje">
                        <div class="cantidad-porcentaje" style="width: 65%;">65%</div>
                    </div>
                </div>
            </div>
        </div>
        <hr>
        <div class="lenguaje-programacion">
            <h1 class="text-light">Kotlin</h1>
            <div class="row">
                <div class="col-6 col-lg-3">
                    <img src="assets/images/kotlin.png" alt="angular" class="img-thumbnail">
                </div>
                <div class="col-6 col-lg-9 container-porcentaje">
                    <div class="porcentaje">
                        <div class="cantidad-porcentaje" style="width: 50%;">50%</div>
                    </div>
                </div>
            </div>
        </div>
        <hr>
        <div class="lenguaje-programacion">
            <h1 class="text-light">Flutter</h1>
            <div class="row">
                <div class="col-6 col-lg-3">
                    <img src="assets/images/flutter.png" alt="angular" class="img-thumbnail">
                </div>
                <div class="col-6 col-lg-9 container-porcentaje">
                    <div class="porcentaje">
                        <div class="cantidad-porcentaje" style="width: 70%;">70%</div>
                    </div>
                </div>
            </div>
        </div>
        <hr>
        <div class="lenguaje-programacion">
            <h1 class="text-light">dart</h1>
            <div class="row">
                <div class="col-6 col-lg-3">
                    <img src="assets/images/dart.png" alt="angular" class="img-thumbnail">
                </div>
                <div class="col-6 col-lg-9 container-porcentaje">
                    <div class="porcentaje">
                        <div class="cantidad-porcentaje" style="width: 75%;">75%</div>
                    </div>
                </div>
            </div>
        </div>
        <hr>
        <div class="lenguaje-programacion">
            <h1 class="text-light">Java</h1>
            <div class="row">
                <div class="col-6 col-lg-3">
                    <img src="assets/images/java.png" alt="angular" class="img-thumbnail">
                </div>
                <div class="col-6 col-lg-9 container-porcentaje">
                    <div class="porcentaje">
                        <div class="cantidad-porcentaje" style="width: 80%;">80%</div>
                    </div>
                </div>
            </div>
        </div>
        <hr>
        <div class="lenguaje-programacion">
            <h1 class="text-light">Python</h1>
            <div class="row">
                <div class="col-6 col-lg-3">
                    <img src="assets/images/python.png" alt="angular" class="img-thumbnail">
                </div>
                <div class="col-6 col-lg-9 container-porcentaje">
                    <div class="porcentaje">
                        <div class="cantidad-porcentaje" style="width: 75%;">75%</div>
                    </div>
                </div>
            </div>
        </div>
        <hr>
        <div class="lenguaje-programacion">
            <h1 class="text-light">Sql Server</h1>
            <div class="row">
                <div class="col-6 col-lg-3">
                    <img src="assets/images/sqlserver.png" alt="angular" class="img-thumbnail">
                </div>
                <div class="col-6 col-lg-9 container-porcentaje">
                    <div class="porcentaje">
                        <div class="cantidad-porcentaje" style="width: 60%;">60%</div>
                    </div>
                </div>
            </div>
        </div>
        <hr>
        <div class="lenguaje-programacion">
            <h1 class="text-light">Mysql</h1>
            <div class="row">
                <div class="col-6 col-lg-3">
                    <img src="assets/images/mysql.png" alt="angular" class="img-thumbnail">
                </div>
                <div class="col-6 col-lg-9 container-porcentaje">
                    <div class="porcentaje">
                        <div class="cantidad-porcentaje" style="width: 75%;">75%</div>
                    </div>
                </div>
            </div>
        </div>
        <hr>
        <div class="lenguaje-programacion">
            <h1 class="text-light">PostgreSql</h1>
            <div class="row">
                <div class="col-6 col-lg-3">
                    <img src="assets/images/postgresql.png" alt="angular" class="img-thumbnail">
                </div>
                <div class="col-6 col-lg-9 container-porcentaje">
                    <div class="porcentaje">
                        <div class="cantidad-porcentaje" style="width: 55%;">55%</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
